import { Status } from "../../components/ui";
import type { AgentDocumentHierarchy } from "../api/e2e";

const DOCUMENT_HIERARCHY_LABELS: Record<AgentDocumentHierarchy, string> = {
  regulatory: "1 · Regulatory",
  company_disclosure: "2 · Company disclosure",
  approved_structured_provider: "3 · Approved structured provider",
  trusted_industry: "4 · Trusted industry",
  approved_sell_side: "5 · Approved sell-side",
  broader_web: "6 · Broader web",
};

export function documentHierarchyLabel(
  hierarchy: AgentDocumentHierarchy | null,
): string {
  if (hierarchy === null) return "Unclassified";
  return DOCUMENT_HIERARCHY_LABELS[hierarchy];
}

export default function AgentDocumentHierarchyBadge({
  hierarchy,
}: {
  hierarchy: AgentDocumentHierarchy | null;
}) {
  let tone: "neutralBg" | "tint" | "warning" = "neutralBg";
  if (hierarchy === "regulatory") tone = "tint";
  if (hierarchy === "broader_web") tone = "warning";
  return (
    <Status tone={tone} className="company-documents__hierarchy">
      {documentHierarchyLabel(hierarchy)}
    </Status>
  );
}
